import { createContext } from 'use-context-selector';

import { AmbientIntelligenceActions, AmbientIntelligenceState } from '../types/ambient-intelligence.types';

// Initial state
export const initialAmbientIntelligenceState: AmbientIntelligenceState = {
  isEnabled: false,
  isLoading: false,
  currentRoute: null,
  suggestions: [],
  activeContent: null,
  sessionId: `session_${Date.now()}`,
  showNudge: false,
  showCards: false,
  currentMode: 'suggestion',
  nudge: {
    currentMode: 'suggestion',
    icon: '✨',
    badge: null,
    userExplicitMode: null,
    lastInteraction: Date.now(),
  },
  communication: {
    threads: [],
    activeThread: null,
    unreadCounts: {
      personal: 0,
      business: 0,
      ai: 0,
    },
    showContactSelector: false,
    showGuestLogin: false,
    draftMessages: {},
  },
  suggestion: {
    scrollPosition: 0,
  },
};

// Create separate contexts for state and actions to optimize re-renders
export const AmbientIntelligenceStateContext = createContext<AmbientIntelligenceState>(
  initialAmbientIntelligenceState,
);

export const AmbientIntelligenceActionsContext = createContext<AmbientIntelligenceActions>({
  pushData: () => {},
  clearData: () => {},
  inspectContent: () => {},
  dismissSuggestions: () => {},
  setSuggestions: () => {},
  setShowNudge: () => {},
  setShowCards: () => {},
  setShowGuestLogin: () => {},
  addCard: () => {},
  setGenericContext: () => {},
  // Mode-related actions
  switchMode: () => {},
  updateNudgeBadge: () => {},
  setNudgeMode: () => {},
  setUnreadCounts: () => {},
  saveDraftMessage: () => {},
  clearDraftMessage: () => {},
});
